(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac3905202f0710b7$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $753de3cb5925592a$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $2f97c2a4ea6269f4$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $ac3905202f0710b7$export$71511d61b312f219)(receiver, descriptor);
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $5d6c3530fa14a187$export$71511d61b312f219(obj, privateMap, value) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $a91e4d47d6e0e68a$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $20d5c04b0c6865c9$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $a91e4d47d6e0e68a$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ $3d28d7f1aac198f5$var$_board = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_score = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_status = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_initialState = /*#__PURE__*/ new WeakMap(), // Add your own methods here
$3d28d7f1aac198f5$var$_createEmptyBoard = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_addRandomTile = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_compressAndMerge = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_move = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_checkWin = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_checkLose = /*#__PURE__*/ new WeakSet();
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_createEmptyBoard);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_compressAndMerge);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkWin);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkLose);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_initialState, {
            writable: true,
            value: void 0
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_initialState, initialState || (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_createEmptyBoard, $3d28d7f1aac198f5$var$createEmptyBoard).call(this));
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, JSON.parse(JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_initialState))));
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, 0);
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "idle"); // 'idle' / 'playing' / 'win' / 'lose'
        // eslint-disable-next-line no-console
        console.log(initialState);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "down");
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score);
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return JSON.parse(JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)));
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status);
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status) === "idle" || (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status) === "lose") {
                    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, JSON.parse(JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_initialState))));
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
                    (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
                    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, 0);
                    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "playing");
                }
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, JSON.parse(JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_initialState))));
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, 0);
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "playing");
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
            }
        }
    ]);
    return Game;
}();
function $3d28d7f1aac198f5$var$createEmptyBoard() {
    return Array.from({
        length: 4
    }, function() {
        return Array(4).fill(0);
    });
}
function $3d28d7f1aac198f5$var$addRandomTile() {
    var emptyCell = [];
    for(var r = 0; r < 4; r++){
        for(var c = 0; c < 4; c++)if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[r][c] === 0) emptyCell.push([
            r,
            c
        ]);
    }
    if (emptyCell.length === 0) return;
    var _emptyCell_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCell[Math.floor(Math.random() * emptyCell.length)], 2), row = _emptyCell_Math_floor[0], col = _emptyCell_Math_floor[1];
    var value = Math.random() < 0.9 ? 2 : 4;
    (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[row][col] = value;
}
function $3d28d7f1aac198f5$var$compressAndMerge(row) {
    var original = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    var nonZero = row.filter(function(v) {
        return v !== 0;
    });
    var newRow = [];
    var scoreGained = 0;
    for(var i = 0; i < nonZero.length; i++)if (nonZero[i] === nonZero[i + 1]) {
        var merged = nonZero[i] * 2;
        newRow.push(merged);
        scoreGained += merged;
        i++;
    } else newRow.push(nonZero[i]);
    while(newRow.length < 4)newRow.push(0);
    var changed = JSON.stringify(original) !== JSON.stringify(newRow);
    return {
        newRow: newRow,
        scoreGained: scoreGained,
        changed: changed
    };
}
function $3d28d7f1aac198f5$var$move(direction) {
    var _this = this;
    if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status) !== "playing") return;
    var clone = function(b) {
        return JSON.parse(JSON.stringify(b));
    };
    var reverseRows = function(m) {
        return m.map(function(r) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(r).reverse();
        });
    };
    var transpose = function(m) {
        return m[0].map(function(_, i) {
            return m.map(function(r) {
                return r[i];
            });
        });
    };
    var board = clone((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board));
    var moved = false;
    var gainedScore = 0;
    // нормалізація: робимо всі рухи "вліво"
    if (direction === "right") board = reverseRows(board);
    else if (direction === "up") board = transpose(board);
    else if (direction === "down") {
        board = transpose(board);
        board = reverseRows(board);
    }
    var newBoard = board.map(function(row) {
        var _class_private_method_get_call = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_compressAndMerge, $3d28d7f1aac198f5$var$compressAndMerge).call(_this, row), newRow = _class_private_method_get_call.newRow, scoreGained = _class_private_method_get_call.scoreGained, changed = _class_private_method_get_call.changed;
        if (changed) moved = true;
        gainedScore += scoreGained;
        return newRow;
    });
    // повертаємо матрицю у початкову орієнтацію
    var result = newBoard;
    if (direction === "right") result = reverseRows(result);
    else if (direction === "up") result = transpose(result);
    else if (direction === "down") {
        result = reverseRows(result);
        result = transpose(result);
    }
    var prev = JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board));
    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, result);
    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score) + gainedScore);
    if (moved && prev !== JSON.stringify((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board))) {
        (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkWin, $3d28d7f1aac198f5$var$checkWin).call(this);
        if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status) !== "win") (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_addRandomTile, $3d28d7f1aac198f5$var$addRandomTile).call(this);
        (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_checkLose, $3d28d7f1aac198f5$var$checkLose).call(this);
    }
}
function $3d28d7f1aac198f5$var$checkWin() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            if (row.includes(2048)) {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "win");
                return;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $3d28d7f1aac198f5$var$checkLose() {
    if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board).flat().includes(0)) return;
    for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
        var val = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[row][col];
        if (row < 3 && (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[row + 1][col] === val || col < 3 && (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[row][col + 1] === val) return;
    }
    (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "lose");
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
// Write your code here
// DOM elements
var $197cd56b15c33885$var$startButton = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$renderBoard() {
    var state = $197cd56b15c33885$var$game.getState().flat();
    $197cd56b15c33885$var$cells.forEach(function(cell, i) {
        var value = state[i];
        cell.textContent = value || "";
        cell.className = "field-cell";
        if (value) cell.classList.add("field-cell--".concat(value));
    });
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    var statusGame = $197cd56b15c33885$var$game.getStatus();
    if (statusGame === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    else if (statusGame === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (statusGame === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
// button Start/Restart
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    } else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$renderBoard();
});
// keyboard
document.addEventListener("keydown", function(ev) {
    switch(ev.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard();
});
$197cd56b15c33885$var$renderBoard();

})();
//# sourceMappingURL=index.17ac6c80.js.map
